"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ExplanationOfBenefit_ProcessNote = exports.ExplanationOfBenefit_ProcessNoteTypeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_positiveInt_1 = require("../Scalar/RTTI_positiveInt");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var ExplanationOfBenefit_ProcessNoteTypeKind;
(function (ExplanationOfBenefit_ProcessNoteTypeKind) {
    ExplanationOfBenefit_ProcessNoteTypeKind["_display"] = "display";
    ExplanationOfBenefit_ProcessNoteTypeKind["_print"] = "print";
    ExplanationOfBenefit_ProcessNoteTypeKind["_printoper"] = "printoper";
})(ExplanationOfBenefit_ProcessNoteTypeKind = exports.ExplanationOfBenefit_ProcessNoteTypeKind || (exports.ExplanationOfBenefit_ProcessNoteTypeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_ExplanationOfBenefit_ProcessNote = t.recursion('IExplanationOfBenefit_ProcessNote', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        number: RTTI_positiveInt_1.RTTI_positiveInt,
        _number: RTTI_Element_1.RTTI_Element,
        type: (0, EnumType_1.createEnumType)(ExplanationOfBenefit_ProcessNoteTypeKind, 'ExplanationOfBenefit_ProcessNoteTypeKind'),
        _type: RTTI_Element_1.RTTI_Element,
        text: t.string,
        _text: RTTI_Element_1.RTTI_Element,
        language: RTTI_CodeableConcept_1.RTTI_CodeableConcept
    });
});
//# sourceMappingURL=RTTI_ExplanationOfBenefit_ProcessNote.js.map